export default "__VITE_ASSET__D7Ucl4Se__"